<section class="qualifying-vehicles" aria-labelledby="qualifying-vehicles-heading">
  <div class="section-heading">
    <div>
      <h2 id="qualifying-vehicles-heading">Qualifying Vehicles</h2>
      <p>All offer sets below will be impacted by the custom rule.</p>
    </div>

    @if (discoveryState?.page; as page) {
      <div class="result-count" aria-label="Qualifying vehicle totals">
        {{ page.items.length }} on this page / {{ page.pagination.totalItems }} total
      </div>
    }
  </div>

  <p class="screen-reader-only" aria-live="polite" aria-atomic="true">
    {{ getLiveAnnouncement() }}
  </p>

  @if (discoveryState?.status === discoveryStatus.Loading) {
    <div class="state-panel loading-state" role="status">
      <p-progressSpinner aria-label="Loading qualifying vehicles"></p-progressSpinner>
      <strong>Loading qualifying vehicles</strong>
      <span>Current results are hidden while the filters are refreshed.</span>
    </div>
  }

  @if (discoveryState?.status === discoveryStatus.Error) {
    <div class="state-panel error-state" role="alert">
      <strong>Qualifying vehicles could not be loaded.</strong>
      <span>{{ discoveryState?.error }}</span>
      <button pButton type="button" label="Retry" icon="pi pi-refresh" (click)="onRetry()"></button>
    </div>
  }

  @if (discoveryState?.status === discoveryStatus.Empty) {
    <div class="state-panel empty-state">
      <strong>No qualifying vehicles found for criteria.</strong>
      <span>Adjust the Rule Details criteria to search again.</span>
    </div>
  }

  @if (discoveryState?.status === discoveryStatus.Success && discoveryState?.page; as page) {
    <div class="table-wrapper">
      <table>
        <caption class="screen-reader-only">Qualifying offer sets in server order</caption>
        <thead>
          <tr>
            @if (selectionEnabled) {
              <th scope="col">Select</th>
            }
            <th scope="col">Vehicle</th>
            <th scope="col">Inventory</th>
            <th scope="col" [attr.aria-sort]="getMaximumPriceAriaSort()">
              <button type="button"
                      class="sort-button"
                      (click)="onMaximumPriceSort()">
                Maximum Price
                <i class="pi" [ngClass]="getMaximumPriceSortIcon()" aria-hidden="true"></i>
              </button>
            </th>
            <th scope="col">Offer Summary</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let source of page.items; trackBy: trackByOfferSetId"
              [class.selected-row]="selectionEnabled && isSelected(source)"
              [class.disabled-row]="selectionEnabled && !source.selectable"
              [class.selectable-row]="selectionEnabled && source.selectable"
              (click)="onSourceChange(source)">
            @if (selectionEnabled) {
              <td class="selection-cell">
                <input type="radio"
                       name="qualifying-source"
                       [id]="getRadioId(source)"
                       [value]="source.offerSetId"
                       [checked]="isSelected(source)"
                       [disabled]="!source.selectable"
                       [attr.aria-label]="getSourceLabel(source)"
                       [attr.aria-describedby]="getDisabledDescriptionId(source)"
                       (change)="onSourceChange(source)">
              </td>
            }
            <td>
              <div class="vehicle-cell">
                <div class="vehicle-image">
                  @if (source.vehicleImage) {
                    <img [src]="source.vehicleImage" [alt]="source.title">
                  }
                </div>
                <div class="vehicle-details">
                  @if (selectionEnabled) {
                    <label [for]="getRadioId(source)" class="source-title">{{ source.title }}</label>
                  } @else {
                    <span class="source-title">{{ source.title }}</span>
                  }
                  <span>Offer-set ID {{ source.offerSetId }}</span>
                  @if (selectionEnabled && !source.selectable) {
                    <span class="disabled-reason" [id]="getDisabledReasonId(source)">
                      {{ getDisabledReason(source) }}
                    </span>
                  }
                </div>
              </div>
            </td>
            <td>
              <span><b>VIN:</b> {{ getOptionalText(source.vin) }}</span>
              <span><b>Stock:</b>  {{ getOptionalText(source.stockNumber) }}</span>
            </td>
            <td>
              @if (source.maximumPrice !== null) {
                {{ source.maximumPrice | currency:'USD':'symbol':'1.0-2' }}
              } @else {
                Not provided
              }
            </td>
            <td class="offer-summary">
              @if (source.percentageDiscountPreview; as preview) {
                <strong>{{ preview.percentageDiscount | number:'1.0-2' }}% off · {{ preview.discountAmount | currency:'USD':'symbol':'1.0-0' }}</strong>
                <div>calculated discount</div>
              } @else if (hasOfferSummary(source)) {
                {{ source.offerSummary }}
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-summary">
      <span>
        Page {{ page.pagination.page }} of {{ page.pagination.totalPages }}
        · {{ page.pagination.totalItems }} qualifying total
      </span>
      <p-paginator [rows]="pageSize"
                   [totalRecords]="page.pagination.totalItems"
                   [first]="(page.pagination.page - 1) * pageSize"
                   [showCurrentPageReport]="true"
                   currentPageReportTemplate="{first} - {last} of {totalRecords}"
                   (onPageChange)="onPageChange($event)">
      </p-paginator>
    </div>
  }

  @if (selectionEnabled && selectedSource !== null) {
    <div class="selected-summary" aria-live="polite">
      <strong>Selected source</strong>
      <span>
         {{ selectedSource.title }} · <b>Offer Set ID:</b> {{ selectedSource.offerSetId }}
      </span>
      <span>
        <b>VIN:</b> {{ getOptionalText(selectedSource.vin) }} ·
        <b>Stock:</b> {{ getOptionalText(selectedSource.stockNumber) }}
      </span>
    </div>
  }
</section>
